import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GolfCourseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"golf_course"}/>
}
